import { Mail, Phone, Globe, MapPin, ExternalLink } from 'lucide-react';

const rowCls = 'flex items-center gap-3 min-w-0 text-sm text-slate-300 hover:text-amber-500 border border-[#2A2F3D] hover:border-amber-500/40 hover:bg-amber-500/5 rounded-lg px-4 py-3 transition-colors group';

export const mapsUrl = (address) => `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;

export const ContactLinks = ({ email, phone, website, address, testPrefix = 'contact' }) => {
  if (!email && !phone && !website && !address) return null;
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {email && (
        <a href={`mailto:${email}`} target="_blank" rel="noopener noreferrer" data-testid={`${testPrefix}-email`} className={rowCls} title="Enviar correo">
          <Mail size={14} className="text-slate-500 group-hover:text-amber-500 shrink-0" />
          <span className="truncate flex-1 min-w-0">{email}</span>
          <span className="text-[10px] font-mono uppercase tracking-widest text-slate-600 group-hover:text-amber-500/70 shrink-0">Escribir</span>
        </a>
      )}
      {phone && (
        <a href={`tel:${phone.replace(/[^+\d]/g, '')}`} data-testid={`${testPrefix}-phone`} className={rowCls} title="Llamar">
          <Phone size={14} className="text-slate-500 group-hover:text-amber-500 shrink-0" />
          <span className="truncate flex-1 min-w-0">{phone}</span>
          <span className="text-[10px] font-mono uppercase tracking-widest text-slate-600 group-hover:text-amber-500/70 shrink-0">Llamar</span>
        </a>
      )}
      {website && (
        <a href={website} target="_blank" rel="noopener noreferrer" data-testid={`${testPrefix}-website`} className={rowCls}>
          <Globe size={14} className="text-slate-500 group-hover:text-amber-500 shrink-0" />
          <span className="truncate flex-1 min-w-0">{website.replace(/^https?:\/\//, '')}</span>
          <ExternalLink size={12} className="text-slate-600 group-hover:text-amber-500/70 shrink-0" />
        </a>
      )}
      {address && (
        <a href={mapsUrl(address)} target="_blank" rel="noopener noreferrer" data-testid={`${testPrefix}-address`} className={rowCls} title="Abrir en Google Maps">
          <MapPin size={14} className="text-slate-500 group-hover:text-amber-500 shrink-0" />
          <span className="truncate flex-1 min-w-0">{address}</span>
          <span className="text-[10px] font-mono uppercase tracking-widest text-slate-600 group-hover:text-amber-500/70 whitespace-nowrap shrink-0">Google Maps ↗</span>
        </a>
      )}
    </div>
  );
};

export default ContactLinks;
